<template>
  <div>
    <a-button type="primary" icon="plus" @click="visible = true">添加物料</a-button>

    <a-modal
        :visible="visible"
        title="添加物料"
        :footer="null"
        @cancel="visible = false"
    >
      <a-form :form="form" :colon="false" @submit="handleSubmit">
        <a-form-item
            label="分类"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-select
              @change="onCategoryChange"
              v-decorator="[
              'category',
              { rules: [{ required: true, message: '请选择！' }] },
            ]"
          >
            <a-select-option
                v-for="item in ['办公文具用品', '电脑周边', '打印耗材', '劳保用品']"
                :key="item"
                :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
            label="商品名称"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-auto-complete
              v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
              :dataSource="nameList"
              placeholder="请选择或输入"
              :filterOption="filterOption"
              @change="onNameChange"
              allowClear
          />
        </a-form-item>

        <a-form-item
            label="规格型号"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-auto-complete
              v-decorator="[
              'spec',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
              :dataSource="specList"
              placeholder="请选择或输入"
              :filterOption="filterOption"
              @change="onSpecChange"
              allowClear
          />
        </a-form-item>

        <a-form-item
            label="颜色"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-input
              v-decorator="[
              'color',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
            label="单位"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-input
              v-decorator="[
              'unit',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
            label="单价(元)"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-input-number
              :formatter="$inputNumberFormat"
              :min="0"
              style="width: 100%"
              v-decorator="[
              'price',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
            label="申领数量"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-input-number
              :min="0"
              style="width: 100%"
              v-decorator="[
              'amount',
              { rules: [{ required: true, message: '请输入！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item
            label="备注"
            :label-col="{ span: 6 }"
            :wrapper-col="{ span: 16 }"
        >
          <a-textarea
              v-decorator="['remark']"
              :auto-size="{ minRows: 2, maxRows: 5 }"
          />
        </a-form-item>

        <div class="right">
          <a-space>
            <a-button type="primary" html-type="submit">保存</a-button>
            <a-button @click="visible = false">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { fetchNamesSpecs } from "@/api/oa/purchaseMaterials";

export default {
  name: "MaterialAdd",

  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      namesSpecsList: [],
      nameList: [],
      specList: [],
    };
  },

  methods: {
    /** 分类切换 → 拉取品名规格列表 */
    onCategoryChange(value) {
      this.namesSpecsList = [];
      this.nameList = [];
      this.specList = [];
      this.form.setFieldsValue({ name: undefined, spec: undefined });
      if (value) {
        fetchNamesSpecs(value).then((res) => {
          this.namesSpecsList = Array.isArray(res) ? res : (res && res.data) || [];
          // 提取去重的商品名称
          const names = [...new Set(this.namesSpecsList.map((item) => item.name).filter(Boolean))];
          this.nameList = names;
        });
      }
    },

    /** 商品名称变化 → 更新规格列表 */
    onNameChange(value) {
      this.specList = [];
      this.form.setFieldsValue({ spec: undefined, color: undefined, unit: undefined, price: undefined });
      if (value) {
        const matched = this.namesSpecsList.filter((item) => item.name === value);
        // specs 可能是数组或字符串，统一展开去重
        const specs = [];
        matched.forEach((item) => {
          if (Array.isArray(item.specs)) {
            specs.push(...item.specs);
          } else if (item.specs) {
            specs.push(item.specs);
          }
        });
        this.specList = [...new Set(specs.filter(Boolean))];
      }
    },

    /** 规格型号变化 → 自动带入颜色、单位、单价 */
    onSpecChange(value) {
      const name = this.form.getFieldValue('name');
      if (!name || !value) return;
      const matched = this.namesSpecsList.find((item) => {
        if (item.name !== name) return false;
        if (Array.isArray(item.specs)) return item.specs.includes(value);
        return item.specs === value;
      });
      if (matched) {
        this.form.setFieldsValue({
          color: matched.color || undefined,
          unit: matched.unit || undefined,
          price: matched.price || undefined,
        });
      }
    },

    /** auto-complete 过滤 */
    filterOption(inputValue, option) {
      return option.componentOptions.children[0].text
          .toLowerCase()
          .includes(inputValue.toLowerCase());
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit("add", {
            ...values,
            id: Date.now(),
          });
          this.visible = false;
          this.form.resetFields();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.right {
  text-align: right;
}
</style>
